const VueHelpers = {
    install(Vue, options) {
        Vue.filter('humanFileSize', function (size) {
            var i = Math.floor( Math.log(size) / Math.log(1024) );
            return ( size / Math.pow(1024, i) ).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
        }),

        Vue.filter('price', function(cents) {
            return window.centsToPrice(cents);
        }),

        Vue.prototype.copyToClipboard = function(string) {
            return new Promise((resolve) => {
                const element = document.createElement('textarea');
                element.value = string;
                document.body.appendChild(element);
                element.select();
                document.execCommand('copy');
                document.body.removeChild(element);

                resolve();
            });
        },

        Vue.prototype.route = function(name, params = []) {
            return window.route(name, params).url();
        },

        Vue.prototype.randomId = function () {
            var randLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26));
            return randLetter + Date.now();
        },

        Vue.prototype.addHttp = function (url) {
            if (!/^(?:f|ht)tps?\:\/\//.test(url)) {
                url = "http://" + url;
            }
            return url;
        },

        Vue.prototype.setUserPreference = function (key, value) {
            localStorage.setItem(`trustup_invoicing_preference_${key}`, value);
        },

        Vue.prototype.getUserPreference = function (key) {
            return localStorage.getItem(`trustup_invoicing_preference_${key}`);
        },

        Vue.prototype.centsToPrice = function (cents) {
            return window.centsToPrice(cents);
        }
    }
};
export default VueHelpers;